var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPingPongActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 43.973,
    viewBox: "0 0 40 43.973",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22",
    "data-name": "Rectangle 22",
    width: 40,
    height: 43.973,
    transform: "translate(0 0)",
    fill: "#0c0c28"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_50",
    "data-name": "Group 50",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_49",
    "data-name": "Group 49",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M25.63,38.209A19.477,19.477,0,0,0,34.3,33.148C41.42,26.024,41.943,15,35.46,8.514S17.95,2.553,10.825,9.678a19.437,19.437,0,0,0-5.06,8.666Z",
    fill: "#0c0c28"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M22.977,38.745,5.222,20.99a16.577,16.577,0,0,0,2.454,9.969.955.955,0,0,1-.159,1.217L.294,38.652a.992.992,0,0,0-.006,1.4l.006.005L3.912,43.68a.992.992,0,0,0,1.4.006l.006-.006L11.8,36.456a.95.95,0,0,1,1.211-.159,16.576,16.576,0,0,0,9.969,2.455Z",
    fill: "#0c0c28"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M5.758,0a4.67,4.67,0,1,1-4.67,4.67A4.67,4.67,0,0,1,5.758,0",
    fill: "#0c0c28"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPingPongActive);
export default __webpack_public_path__ + "static/media/ping-pong-active.6b07378f8b2c7b9549d649a715f55027.svg";
export { ForwardRef as ReactComponent };